import { render, staticRenderFns } from "./portraitArticle.vue?vue&type=template&id=7c2faeb1"
import script from "./portraitArticle.vue?vue&type=script&lang=js"
export * from "./portraitArticle.vue?vue&type=script&lang=js"
import style0 from "./portraitArticle.vue?vue&type=style&index=0&id=7c2faeb1&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports